export class Assumption {
    inflation?: number = undefined
    investmentReturn?: number = undefined
    educationInflationRate?: number = undefined
    salaryIncrementRate?: number = undefined
    retirementIncome?: number = undefined
    inflationAdjustedReturn?: number = undefined
}
